// MÂNA CURENTĂ (format 3.9, §27): bagheta de pe creasta unei balustrade — un
// obiect al ei în document (`props["architecture.railing"].handrail`), cu
// profil, secțiune, material și culoare. Până la 3.9 era numai desen: o bară
// neagră de 5 × 5 cm pe sticlă, lamele și parapetul plin. Un document mai vechi
// (fără cheie) o primește tot pe aceea; `null` = stilul a scos-o.

export interface ManaCurenta {
  profile: "rect" | "round";
  width_m: number;
  height_m: number;
  material?: string;
  colour?: string;
  length_m?: number;
}

export const MANA_IMPLICITA: ManaCurenta = {
  profile: "rect", width_m: 0.05, height_m: 0.05, material: "mana_curenta_otel", colour: "#2a2c2f",
};

/** Mâna curentă din `props["architecture.railing"]`: `undefined` = documentul
 *  n-o scrie (mai vechi de 3.9), `null` = scoasă, altfel obiectul ei. */
export function manaDinProps(p: unknown): ManaCurenta | null | undefined {
  if (!p || typeof p !== "object" || !("handrail" in p)) return undefined;
  const m = (p as { handrail: unknown }).handrail;
  if (!m || typeof m !== "object") return null;
  const o = m as Record<string, unknown>;
  const nr = (v: unknown, d: number) => (typeof v === "number" && v > 0 ? v : d);
  const profile = o.profile === "round" ? "round" : "rect";
  const width_m = nr(o.width_m, MANA_IMPLICITA.width_m);
  return {
    profile, width_m,
    height_m: profile === "round" ? width_m : nr(o.height_m, MANA_IMPLICITA.height_m),
    material: typeof o.material === "string" ? o.material : undefined,
    colour: typeof o.colour === "string" ? o.colour : undefined,
    length_m: typeof o.length_m === "number" ? o.length_m : undefined,
  };
}

/** Ce mână curentă DESENEZ pe o balustradă: cea scrisă, niciuna când e scoasă,
 *  iar la un document fără cheie bara de dinainte, pe sticlă, lamele și plin. */
export function manaDeDesenat(r: { kind: string; handrail?: ManaCurenta | null }): ManaCurenta | null {
  if (r.handrail === null) return null;
  if (r.handrail) return r.handrail;
  return r.kind === "glass" || r.kind === "slats" || r.kind === "solid" ? MANA_IMPLICITA : null;
}
